// ── After a connect or payout flow ───────────────────────────────────────────
// The app has no onboarding lock: once an athlete has a password and has accepted the terms,
// everything is open. Flows that leave the app (social OAuth, Stripe) come back here.

/** Where to land after connecting Instagram, TikTok or YouTube */
export const afterSocialConnect = (_athlete?: unknown) => '/settings?tab=social'

/** Where to land after (or instead of) Stripe bank setup */
export const afterPayoutSetup = (_athlete?: unknown) => '/earnings'
